class ToggleCategory extends HTMLElement {
    constructor() {
      super();
      this.onCategoryClick = this.onCategoryClick.bind(this);
    }
  
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.category-button'));
      this.items   = Array.from(this.querySelectorAll('toggle-item'));
  
      this.buttons.forEach(btn => {
        btn.addEventListener('click', this.onCategoryClick);
      });
  
      if (this.buttons.length) {
        this.buttons[0].click();
      }
    }
  
    onCategoryClick(event) {
      const clicked = event.currentTarget;
      const category = clicked.dataset.category;

      this.buttons.forEach(btn => {
        btn.classList.toggle('active', btn === clicked);
      });
  
      this.items.forEach(item => {
        const match = item.dataset.category === category;
        item.style.display = match ? '' : 'none';
      });
    }
  
    disconnectedCallback() {
      this.buttons.forEach(btn => {
        btn.removeEventListener('click', this.onCategoryClick);
      });
    }
  }
  
  customElements.define('toggle-category', ToggleCategory);
  